import { selectAccountChatRoomId } from 'selectors/app/selectAccountPreferences'
import { doSyncSearches } from './doSyncSearches'

let isSubscribed = false
export function subscribeSyncSearches(client) {
  return (dispatch, getState) => {
    if (isSubscribed) return
    const accountRoomId = selectAccountChatRoomId(getState())
    client.on('event', event => {
      if (event.getType() !== 'g.sync.searches') return
      if (event.getRoomId() !== accountRoomId) return
      dispatch(doSyncSearches(event))
    })
    isSubscribed = true
  }
}
